/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RequesterExistsResponse } from '../models/RequesterExistsResponse';
import type { RequesterRead } from '../models/RequesterRead';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RequestersService {

    /**
     * Search Requesters
     * Fuzzy search requesters scoped to the current OpCo.
     * @param fullName
     * @param opco
     * @param limit
     * @returns RequesterRead Successful Response
     * @throws ApiError
     */
    public static searchRequestersRequestersSearchGet(
        fullName: string,
        opco: string,
        limit: number = 5,
    ): CancelablePromise<Array<RequesterRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/requesters/search',
            query: {
                'full_name': fullName,
                'limit': limit,
                'opco': opco,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Requester Exists
     * Check if requester exists in the database.
     * @param username
     * @param opco
     * @returns RequesterExistsResponse Successful Response
     * @throws ApiError
     */
    public static requesterExistsRequestersUsernameExistsGet(
        username: string,
        opco: string,
    ): CancelablePromise<RequesterExistsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/requesters/{username}/exists',
            path: {
                'username': username,
            },
            query: {
                'opco': opco,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
